import { addDoc, collection, doc, getDoc, getDocs, limit, orderBy, query, serverTimestamp, setDoc, startAfter, Timestamp, where } from "firebase/firestore";
import { userDoc } from "../models/userModel";
import { eventsCollection } from "../models/eventModel";
// import moment from "moment";
import { db } from "../../firebase/firebase";
import moment from 'moment-timezone';
import { meetingsCollection } from "../models/meetingModel";


// export const createEvent = async (data) => {
//     try{
//     const {name, DateAndTime, duration, description, createdBy, remainderTime, venue, assigneeId } = data;

//     const createdByRef = userDoc(createdBy);
//     const assigneeRef = userDoc(assigneeId);
//     const modifiedByRef = userDoc(createdBy);


//     const eventStartTimestamp = Timestamp.fromDate(
//       moment(DateAndTime, "MM-DD-YYYY HH:mm").utcOffset("+05:30").toDate()
//     );
//     const eventEndTimestamp = Timestamp.fromDate(

//      moment(eventStartTimestamp.toDate())
//       .add(duration, 'minutes')
//       .toDate()
//     );

//     const setRemainderTimestamp = Timestamp.fromDate(moment(eventStartTimestamp.toDate())
//       .subtract(remainderTime, 'minutes')
//       .toDate());    

// const eventData = {
//     name: name,
//     searchKey: name.toLowerCase().trim(),
//     eventStartTimestamp: eventStartTimestamp,
//     eventEndTimestamp: eventEndTimestamp,
//     durationInMinutes: duration,
//     description: description,
//     createdBy: createdByRef,
//     modifiedBy: modifiedByRef,
//     remainderInMinutes: remainderTime,
//     remainderTimestamp: setRemainderTimestamp,
//     venue: venue,
//     responsiblePerson: assigneeRef,
//     status: "PENDING",
//     createdTimestamp: serverTimestamp(),
//     lastModifiedTimestamp: serverTimestamp(),

// }

// const eventRef = await addDoc(eventsCollection, eventData);
// return "Event created Successfully";

//     }catch(error){
//         console.error("Error creationg event:", error);
//         throw new Error("Error creating event: " + error.message);

//     }
// }

export const createEvent = async (data) => {
  try {
    const {
      name,
      date,              
      time,              
      durationHours,     
      durationMinutes,   
      description,
      setReminder,       
      createdById,
      venue,
      assigneeId
    } = data;

    const createdByRef = userDoc(createdById);
    const assigneeRef = userDoc(assigneeId);
    const modifiedByRef = userDoc(createdById);

    // Combine date and time to form datetime string
    const dateTimeString = `${date} ${time}`; // "2025-08-12 15:51"

    // Parse event start timestamp
    const eventStartTimestamp = Timestamp.fromDate(
      moment(dateTimeString, "YYYY-MM-DD HH:mm").utcOffset("+05:30").toDate()
    );

    // Convert duration to total minutes
    const totalDurationMinutes =
      parseInt(durationHours, 10) * 60 + parseInt(durationMinutes, 10);

    // Calculate event end timestamp
    const eventEndTimestamp = Timestamp.fromDate(
      moment(eventStartTimestamp.toDate())
        .add(totalDurationMinutes, 'minutes')
        .toDate()
    );

    // Calculate reminder timestamp
    const setReminderMinutes = parseInt(setReminder, 10);
    const setRemainderTimestamp = Timestamp.fromDate(
      moment(eventStartTimestamp.toDate())
        .subtract(setReminderMinutes, 'minutes')
        .toDate()
    );

    const eventData = {
      title: name,
      isEvent: true,
      contactPerson: null,
      closureNotes: null,
      searchKey: name.toLowerCase().trim(),
      meetingStartTimestamp: eventStartTimestamp,
      meetingEndTimestamp: eventEndTimestamp,
      meetingDurationInMinutes: totalDurationMinutes,
      meetingDescription: description,
      createdBy: createdByRef,
      modifiedBy: modifiedByRef,
      reasonForReschedule: null,
      remainderInMinutes: setReminderMinutes,
      remainderTimestamp: setRemainderTimestamp,
      meetingPlace: venue,
      responsiblePerson: assigneeRef,
      meetingStatus: "NOT_YET_STARTED",
      createdTimestamp: serverTimestamp(),
      lastModifiedTimestamp: serverTimestamp(),
    };

    const eventRef = await addDoc(meetingsCollection, eventData);

await addDoc(collection(eventRef, "history"), {
  action: "Event Created",
  historyTimestamp: serverTimestamp(),
  meetingScheduledTimestamp: eventStartTimestamp,
  changeBy: createdByRef,
  existingMeetTimestamp: null,
  newAssigneeUid: null,
  previousAssigneeUid: null,
  reasonForReschedule: null

});



    return "Event created Successfully";

  } catch (error) {
    console.error("Error creating event:", error);
    throw new Error("Error creating event: " + error.message);
  }
};



export const getAllEvents = async ({limitCount = 10, startAfterDoc = null, 
    sortBy = "lastModifiedTimestamp", searchKey = "",
    assigneeId = "",
  startDate = "",
  endDate = "",
  status = "",
}) =>{

  let queryConstraints = [];

  const baseWhere = where("isEvent", "==", true);
  queryConstraints.push(baseWhere);
if (assigneeId) {
  const assigneeRef = doc(db, "users", assigneeId);
  queryConstraints.push(where("responsiblePerson", "==", assigneeRef));
}


if (startDate && endDate) {
  const startTimestamp = Timestamp.fromDate(
    moment(startDate, "MM-DD-YYYY").utcOffset("+05:30").startOf("day").toDate()
  );
  const endTimestamp = Timestamp.fromDate(
moment(endDate, "MM-DD-YYYY").utcOffset("+05:30").endOf("day").toDate());
  queryConstraints.push(
    where("meetingStartTimestamp", ">", startTimestamp),
    where("meetingStartTimestamp", "<=", endTimestamp)
  );
}

if (status) {
    queryConstraints.push(where("meetingStatus", "==", status)); 
  }

  queryConstraints.push(orderBy(sortBy, "desc"));
  queryConstraints.push(limit(limitCount));

  if (startAfterDoc) {
    const startRef = doc(db, "meetings", startAfterDoc);
    const startSnap = await getDoc(startRef);
    queryConstraints.push(startAfter(startSnap));
  }



  const baseQuery = query(meetingsCollection, ...queryConstraints);
    const snapshot = await getDocs(baseQuery);
  
    const events = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));


      const formattedEvents = await Promise.all(
      events.map(async (event) => {
        const {
          title,
          responsiblePerson,
          meetingStatus,
          meetingEndTimestamp,
          meetingDurationInMinutes,
          meetingStartTimestamp,
          meetingPlace,
          meetingDescription,
          remainderInMinutes
        } = event;
    
        const [assigneeSnap] = await Promise.all([
          getDoc(responsiblePerson),
        ]);
    
    const assigneeData = assigneeSnap.exists() ? assigneeSnap.data() : null;
    
    const assignee = assigneeData
      ? {
          name: assigneeData.name || "Unknown",
          id: assigneeSnap.id,
        }
      : {
          name: "Unknown",
          id: "",
        };
    
        const start = meetingStartTimestamp.toDate();
        const end = meetingEndTimestamp.toDate();
    
        const eventDateIn = moment(start).tz("Asia/Kolkata").format("YYYY-MM-DD");
        const eventDateOut = moment(start).tz("Asia/Kolkata").format("DD-MM-YYYY");

        const startTime = start.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        const startTime24Hours = start.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        const endTime = end.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
    
        // here now send the duration in minutes, duration in hours sepately in db it stored as minutes 

        const durationInHours = Math.floor(meetingDurationInMinutes / 60);
        const durationInMinute = meetingDurationInMinutes % 60;

        return {
            id: event.id,
            name:title,
            assignee,
            date:eventDateIn,
            dateOut: eventDateOut,
            eventDuration: `${startTime} - ${endTime}`,
            time: startTime24Hours,
            durationHours: durationInHours,
            durationMinutes: durationInMinute,
            setReminder: remainderInMinutes,
            status: meetingStatus,
            venue: meetingPlace,
            description: meetingDescription,

            
        }

   
      })
    );
    
    
      return {
        events: formattedEvents,
        firstVisible: snapshot.docs[0],
        lastVisible: snapshot.docs[snapshot.docs.length - 1] || null,
      };
}


export const eventHistory = async ({ eventId }) => {
  if (!eventId) throw new Error("Event ID is required");

  const historyRef = collection(db, "meetings", eventId, "history");
  const snapshot = await getDocs(historyRef);

  const historyRecords = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  const response = await Promise.all(
    historyRecords.map(async (data) => {
      const historyTime = data.historyTimestamp.toDate().toLocaleDateString("en-GB");
      return {
        log: data.action,
        time: historyTime,
      };
    })
  );

  return response;
};


export const updateEvent = async (data) => {
  try {
    const {
      eventId,
      name,
      date,
      time,
      durationHours,
      durationMinutes,
      description,
      setReminder,
      modifiedById,
      venue,
    } = data;

    // Validate required fields
    if (!eventId) throw new Error("Event ID is required");
    if (!name || !date || !time || !durationHours || !durationMinutes || !setReminder || !modifiedById) {
      throw new Error("Missing required fields");
    }

    const modifiedByRef = userDoc(modifiedById);

    // Reference and fetch the event
    const eventRef = doc(db, "meetings", eventId);
    const eventSnap = await getDoc(eventRef);

    if (!eventSnap.exists()) {
      throw new Error("Event not found");
    }

    const existingEventData = eventSnap.data();

    // Construct full datetime string and parse it
    const dateTimeString = `${date} ${time}`; // "YYYY-MM-DD HH:mm"
    const eventStartTimestamp = Timestamp.fromDate(
      moment.tz(dateTimeString, "YYYY-MM-DD HH:mm", "Asia/Kolkata").toDate()
    );

    // Calculate duration
    const totalDurationMinutes = parseInt(durationHours, 10) * 60 + parseInt(durationMinutes, 10);

    const eventEndTimestamp = Timestamp.fromDate(
      moment(eventStartTimestamp.toDate()).add(totalDurationMinutes, "minutes").toDate()
    );

    const setReminderMinutes = parseInt(setReminder, 10);
    const setRemainderTimestamp = Timestamp.fromDate(
      moment(eventStartTimestamp.toDate()).subtract(setReminderMinutes, "minutes").toDate()
    );

    // Prepare updated event data
    const updatedEventData = {
      ...existingEventData, // Retain untouched fields
      title:name,
      searchKey: name.toLowerCase().trim(),
      meetingStartTimestamp:eventStartTimestamp,
      meetingEndTimestamp:eventEndTimestamp,
      meetingDurationInMinutes: totalDurationMinutes,
      meetingDescription:description,
      modifiedBy: modifiedByRef,
      remainderInMinutes: setReminderMinutes,
      remainderTimestamp: setRemainderTimestamp,
      meetingPlace:venue,
      lastModifiedTimestamp: serverTimestamp(),
    };

    await addDoc(collection(eventRef, "history"), {
      action: "Event Updated",
      historyTimestamp: serverTimestamp(),
      meetingScheduledTimestamp: eventStartTimestamp,
      changeBy: modifiedByRef,
    });

    await setDoc(eventRef, updatedEventData, { merge: true });

    return "Event updated successfully";

  } catch (error) {
    console.error("Error updating event:", error);
    throw new Error("Error updating event: " + error.message);
  }
};